var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#EBFAF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5013 8.91602C17.7109 8.91602 8.91797 17.7089 8.91797 28.4993C8.91797 39.2898 17.7109 48.0827 28.5013 48.0827C39.2917 48.0827 48.0846 39.2898 48.0846 28.4993C48.0846 17.7089 39.2917 8.91602 28.5013 8.91602ZM37.8621 23.9952L26.7584 35.0989C26.4842 35.3731 26.1121 35.5298 25.7205 35.5298C25.3288 35.5298 24.9567 35.3731 24.6826 35.0989L19.1405 29.5568C18.5726 28.9889 18.5726 28.0489 19.1405 27.481C19.7084 26.9131 20.6484 26.9131 21.2163 27.481L25.7205 31.9852L35.7863 21.9193C36.3542 21.3514 37.2942 21.3514 37.8621 21.9193C38.4301 22.4873 38.4301 23.4077 37.8621 23.9952Z",
    fill: "#0CB95B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/green-tick-circle.4812c157.svg";
export { ForwardRef as ReactComponent };